import "core-js/modules/es.array.includes.js";
function getContentItemType(contentItem) {
  var includeCustomType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var type = (includeCustomType && 'customType' in contentItem ? contentItem.customType : null) || 'fileFormat' in contentItem && contentItem.fileFormat || contentItem.type;
  if (type && ['upload', 'zip', 'scorm'].includes(type)) {
    type = 'asset';
  }
  return type || 'asset';
}
export function getContentItemTypeTranslationKey(type) {
  return "file_type_".concat(type);
}
export default getContentItemType;